import React from 'react';
export function GiftBackground() {
  return <div className="absolute inset-0 overflow-hidden pointer-events-none" data-id="element-157">
      {/* Gradient Overlays only, floating symbols removed */}
      <div className="absolute inset-0 bg-gradient-to-b from-blue-50/50 via-transparent to-blue-50/50" data-id="element-158" />
    </div>;
}